<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="week" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('week')">
                                        <multi-selectbox
                                            v-model="formData.week"
                                            :options="weekOptions"
                                            :multiple="false"
                                            :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="subject" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('subject')">
                                        <b-form-textarea v-model="formData.subject"
                                                         :class="errors[0] ? 'is-invalid':''"
                                                         rows="6" />
                                        <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="subject_en" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('subject')+' (EN)'">
                                        <b-form-textarea v-model="formData.subject_en"
                                                         :class="errors[0] ? 'is-invalid':''"
                                                         rows="6" />
                                        <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="preliminary" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('preliminary_course_material')">
                                        <b-form-textarea v-model="formData.preliminary"
                                                         :class="errors[0] ? 'is-invalid':''"
                                                         rows="6" />
                                        <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <ValidationProvider name="preliminary_en" rules="" v-slot="{errors}">
                                    <b-form-group :label="$t('preliminary_course_material')+' (EN)'">
                                        <b-form-textarea v-model="formData.preliminary_en"
                                                         :class="errors[0] ? 'is-invalid':''"
                                                         rows="6" />
                                        <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button
                    variant="primary"
                    @click="save"
                    :disabled="formLoading">
                    {{ $t("save") }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"

// Services
import EctsService from "@/services/EctsService"

// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        MultiSelectbox
    },
    props: {
        course: {
            type: Object,
        },
    },
    data() {
        return {
            formLoading: false,
            formData: {},
        };
    },
    computed: {
        weekOptions(){
            let result = []
            for(let i=1; i < 15; i++){
                result.push({
                    value: i,
                    text: i+'. '+this.$t('week')
                })
            }
            return result
        }
    },
    created() {
        this.formData = this.course
    },
    methods: {
        async save(){
            const isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                this.formLoading = true
                if(this.formData.actionType == 'new'){
                    this.formData.course_id = this.formData.id
                    EctsService.storeProgramCoordinatorWeeklyCoursePlan(this.formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('closeComponent', {
                            data: this.course,
                            component: 'weekly-course-plan',
                        })
                        this.formLoading = false
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                        this.formLoading = false
                    })
                } else {
                    EctsService.updateProgramCoordinatorWeeklyCoursePlan(this.formData.id, this.formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.course.id = this.course.course_id
                        this.$emit('closeComponent', {
                            data: this.course,
                            component: 'weekly-course-plan',
                        })
                        this.formLoading = false
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                        this.formLoading = false
                    })
                }

            }
        }
    },
}
</script>
